import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { ActionBar, Button, Modal, Text } from '@beef/ui-kit';
import { Picture } from '@beef/smart-kit';
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var StatusModal = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    description = _ref.description,
    img = _ref.img,
    buttonText = _ref.buttonText,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Modal, {
    actionBar: buttonText ? /*#__PURE__*/React.createElement(ActionBar, {
      size: "s"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      size: "m",
      variant: "main",
      "data-t-id": "components-StatusModal"
    }, buttonText)) : undefined,
    isCloseButtonVisible: true,
    isOpen: true,
    onClose: onClose,
    size: "m",
    "data-t-id": "components-StatusModal"
  }, img && /*#__PURE__*/React.createElement(Picture, {
    alt: img.alt,
    src: img.src
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('content')
  }, title && /*#__PURE__*/React.createElement(Text, {
    size: "size2-m"
  }, title), description && /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, description)));
});
StatusModal.displayName = StatusModal.name;